// Frontend: Updated OrderList component with clickable rows
import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
} from "@mui/material";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import StatusBadge from "./OrderStatusBadge";

const statusLabels = {
  ready_to_process: "Ordered",
  processing: "Processing",
  processed: "Ready to Pick Up",
  delivered: "Picked Up",
  Ordered: "Ordered",
  new: "Ordered",
  ordered: "Ordered",
};

const OrderList = ({ orders, orderBy, order, onRequestSort }) => {
  const handleSort = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
                active={orderBy === "date"}
                direction={order === "asc" ? "asc" : "desc"}
                onClick={handleSort("date")}
              >
                Date
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "productType"}
                direction={order === "asc" ? "asc" : "desc"}
                onClick={handleSort("productType")}
              >
                Product Type
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "orderNumber"}
                direction={order === "asc" ? "asc" : "desc"}
                onClick={handleSort("orderNumber")}
              >
                Order#
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "tag"}
                direction={order === "asc" ? "asc" : "desc"}
                onClick={handleSort("tag")}
              >
                Tag
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "productMaterial"}
                direction={order === "asc" ? "asc" : "desc"}
                onClick={handleSort("productMaterial")}
              >
                Material
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "orderFactor"}
                direction={order === "asc" ? "asc" : "desc"}
                onClick={handleSort("orderFactor")}
              >
                SQFT
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "quantity"}
                direction={order === "asc" ? "asc" : "desc"}
                onClick={handleSort("quantity")}
              >
                Quantity
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === "orderStatus"}
                direction={order === "asc" ? "asc" : "desc"}
                onClick={handleSort("orderStatus")}
              >
                Status
              </TableSortLabel>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders &&
            orders.map((order) => {
              const statusLabel = statusLabels[order.orderStatus] || "Unknown";

              return (
                <TableRow 
                  key={order._id}
                  component={Link}
                  to={`/order-detail/${order._id}`} 
                  sx={{
                    cursor: "pointer",
                    textDecoration: "none",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <TableCell>
                    {new Date(order.createdAt).toLocaleDateString()}
                  </TableCell>
                  <TableCell>{order.productType}</TableCell>
                  <TableCell>{order.orderNumber || "N/A"}</TableCell>
                  <TableCell>{order.tag}</TableCell>
                  <TableCell>
                    {(() => {
                      if (typeof order.productMaterial === 'string') {
                        return order.productMaterial; 
                      } else if (order.productMaterial && typeof order.productMaterial === 'object' && 'name' in order.productMaterial) {
                        return order.productMaterial.name; 
                      } else {
                        return 'N/A'; 
                      }
                    })()}
                  </TableCell>
                  <TableCell>{order.orderFactor}</TableCell>
                  <TableCell>{order.orderArray.length}</TableCell>
                  <TableCell>
                    <StatusBadge status={order.orderStatus} />
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OrderList;